<template>
    <div id="ContainerStandingOrders">
        <div class="page-height">
            <div class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="isScheduleDB ? PatientTitle : RegistrationInfo"
                    v-bind:titlePrefix="$t('StandingOrders.MedicationProtocol')"
                    v-bind:titleRef="'titleElementMedication'"
                    v-bind:patientCode="this.$route.params.id">
                </MdTitleRegInfo>

                <b-row>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientAllergies
                            v-bind:NoUseClass="false"
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddAllergy="'AddAllergyMed'"
                            v-bind:VisibleAllergy="true"
                            v-bind:UseColumnDinamic="true"
                            v-bind:Column="'col-md-12'"
                            v-bind:PatientCode="this.$route.params.id"
                            v-bind:NoValidateChanges="true">
                        </MdPatientAllergies>
                    </b-col>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientSpecialPrecautions
                            v-bind:NoUseClass="false"
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddSpecialPrecautions="'AddSpecialPrecautionMed'"
                            v-bind:VisibleSpecialPrecautions="true"
                            v-bind:UseColumnDinamic="true"
                            v-bind:Column="'col-md-12'"
                            v-bind:PatientCode="this.$route.params.id"
                            v-bind:NoValidateChanges="true">
                        </MdPatientSpecialPrecautions>
                    </b-col>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientMarsAlert
                            v-bind:NoUseClass="false"
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddMarksAlert="'AddMarsAlertsMed'"
                            v-bind:VisibleMarsAlert="true"
                            v-bind:UseColumnDynamic="true"
                            v-bind:Column="'col-md-12'"
                            v-bind:PatientCode="this.$route.params.id"
                            v-bind:NoValidateChanges="true">
                        </MdPatientMarsAlert>
                    </b-col>
                </b-row>

                <MdTitle v-bind:VisibleInfo="false" v-bind:Text="CreatedBy" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <b-row>
                    <b-col md="3" lg="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Prescriber')"
                            v-bind:Options="PrescriberList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="false"
                            v-bind:Model="ModelPrescriber"
                            v-bind:Multiple="false"
                            v-bind:isRequired="true"
                            v-bind:isValid="isPrescriberValid"
                            :Input="ChangeDropDownPrescriber"
                            v-bind:FeedBackText="$t('Insurance.InsuranceTypeRequired')"
                            />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="protocol.code"
                            v-bind:ModelDescription="protocol.description"
                            v-bind:Label="$t('StandingOrders.MedicationProtocol')"
                            v-bind:RefCode="'Protocol'"
                            v-bind:Api="'StandingOrderHdrs?Active=true&OrderBy=1'"
                            v-bind:FieldCode="'code'"
                            v-bind:isValid="isProtocolValid"
                            v-bind:isRequired="true"
                            v-bind:FieldDescription="'description'"
                            :SearchTitle="$t('StandingOrders.MedicationProtocol')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'Code'"
                            v-bind:Fields="BaseFields"
                        />
                    </b-col>
                </b-row>

                <MdTitle v-bind:VisibleInfo="false" v-bind:Text="$t('Medication.Medications')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                <div v-if="protocol.code == ''" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite">
                    <div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div>
                </div>

                <b-row>
                    <b-col md="12" lg="12" sm="12">
                        <div class="zebraAccordion">
                            <div class="zebraRow" v-for="(item, index) in prescriptions" :key="index">
                                <div class="accordion" role="tablist" >
                                    <div class="zebraItem" v-b-toggle="'accordion-'+index">
                                        <div class="container-fluid">
                                            <div class="row d-flex justify-content-between align-items-center">
                                                <div class="col-md-11">
                                                    <div class="d-flex align-items-center">
                                                        <span @click="toggleSelectState($event, index)" @click.stop :class="item.selected ? 'rounded-circle tableActionBTN tableBTNtext ikon med-status-complete checkboxBTNChecked' : 'rounded-circle tableActionBTN tableBTNtext ikon med-status-complete checkboxBTN'"></span>
                                                            <span class="mx-2">
                                                                <span>{{ item.drugName }} - {{ item.dosage }}  {{item.unitOfMeasure}} - {{item.frequencyDescription}} - {{item.day}} {{$t('Shared.Days')}}

                                                                <br>
                                                                <small class="ml-2">
                                                                    <span class="PRNlabel" v-if="item.mode === 'PRN'" v-b-tooltip.hover title="Pro Re Nata (as needed)">PRN</span>
                                                                    <span class="blinkingSTAT" v-if="item.mode === 'STAT'">STAT</span>
                                                                    <span class="DrugOrderType mx-1" v-on:click="OpenDrugInfo(item)" >{{$t('Shared.DrugInfo')}}</span>
                                                                </small>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-md-1">
                                                    <div class="pull-right">
                                                        <i v-if="!item.isValidateRequired" class="ikon med-show-errors redIconColorHeader h3" v-b-tooltip.hover :title="item.errorMessage ? item.errorMessage : $t('Msg.CheckRedLabeledFields')"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <b-card no-body>
                                    <b-collapse :id="'accordion-'+index" accordion="my-accordion" role="tabpanel">
                                        <StandingOrderDrug
                                            :key="index"
                                            v-model="prescriptions[index]"
                                            :index="index"
                                            :ref="`StandingOrderDrug_${index}`"
                                            v-bind:ActionList="ActionList"
                                            v-bind:RouteNameList="RouteNameList"
                                            v-bind:WhenList="WhenList"
                                            v-bind:ReasonList="ReasonList"
                                            v-bind:DiagnosisList="DiagnosisList"
                                            v-bind:IndicationsList="IndicationsList"
                                            v-bind:PharmacyOption="PharmacyOption"
                                            @UpdateDiagnosiList="getDiagnosisByPatientCode()"
                                        >
                                        </StandingOrderDrug>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>

        <BaseModal
                v-if="DataBankVisible"
                ModalId="ModalDataBank"
                :key="'ModalDataBank'"
                :TitleWindow="FirstDataDrugName ? `Drug Information - `+FirstDataDrugName : `Drug Information`"
                :width="'70%'"
                :height="'85vh'"
                :UseUpClass="true"
                :HideModalFun="DataBankOnCancel"
                @Close="DataBankOnCancel"
                :buttons="[
                    { text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }
                ]">

                <DataBankSearch
                    :SearchCriteria.sync="SearchBank"
                    :DrugCode="this.DrugCode"
                    :PatientCode="this.$route.params.id || this.PatientCode"
                    :AdmissionRecordId="AdmRecordId"
                    @UpdateDataDrugName="UpdateDataDrugName">
                </DataBankSearch>

            </BaseModal>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btn_list_medications'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DiscardChanges"/>

            <MdButton
                v-bind:Label="$t('Shared.Save')"
                style="z-index:99999"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly="this.prescriptions.length === 0 || !existPrescriptionSelected()"
                v-bind:Name="'btn_save_medications'">
            </MdButton>
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Permission from '@/common/Permission'
import Utils from "@/common/utils"
import EnumService from '@/services/enum.service'
import MedicationService from '@/services/medication.service'
import StorageService from '@/services/storage.service'
import IndicationService from '@/services/indication.service'
import GlobalService from '@/services/global.service'
import PatientService from '@/services/patient.service'
import PharmacyOptions from '@/services/pharmacyoption.service'
import StandingOrderDrug from '@/components/pages/clinical/medications/StandingOrders/StandingOrderDrug'
import { EventBus } from '@/event-bus.js';

export default {
beforeRouteLeave(to, from, next) {
        if (this.getPendingChanges()) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                            title: this.$t('Shared.Confirm'),
                            okTitle: this.$t('Shared.BtnSave'),
                            cancelTitle: this.$t('Shared.BtnDismiss'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning'
                        })
                        .then(async value => {
                            if(!value){
                                next();
                            } else {
                                await this.ClickOffRoute();
                                var f = this.WasSaved;
                                if(f){
                                    next();
                                }
                            }
                        })
        } else {
            next()
        }
    },

    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'StandingOrders',
    components: {
        StandingOrderDrug
    },

    data() {
        return {
            DataBankVisible:false,
            SearchBank:"",
            FirstDataDrugName:"",
            AdmRecordId:null,
            DrugCode:null,
            DrugName:"",
            PatientCode:null,
            isScheduleDB: false,
            isProtocolValid: true,
            PatientTitle:{
                programName:'',
                fullName:'',
                admitDate:'',
                dischargeDate:'',
                dob:'',
                activitytypename:'',
                startdatetime:'',
                ageFormatted:''
            },
            RegistrationInfo: {},
            OptionsRightMenu:{
                visible:true,
                ItemsList:[],
                btnvisible:true,
                itemdisabled: false,
            },
            protocol: {
                code: '',
                description: ''
            },
            BaseFields:[
                { key: 'description', sortable: true, label: this.$t('Shared.Description')},
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class:'hidden'},
                { key: 'diagDescription', sortable: true, label: this.$t('Shared.DiagnosisDescription')},
                { key: 'diagCode', sortable: true, label: this.$t('Shared.DiagnosisCode')},
                { key: 'remarks', sortable: true, label: this.$tc('Shared.Note',1)},
            ],
            prescriptions: [],
            CreatedBy: this.$t('Shared.CreatedBy') + ': '+ Utils.strToTitleCase(StorageService.getName()) + ' <span class="highlightInTitle blueTitle">'+ this.$t('Shared.New')+'</span>',
            ModelPrescriber: {code:"", name:""},
            isPrescriberValid:true,
            PrescriberList:[],
            DiagnosisList:[],
            IndicationsList:[],
            ActionList:[],
            RouteNameList:[],
            WhenList:[],
            OrderTypeList:[],
            UsageList:EnumService.ClinicalMedicationUsage,
            RxStatusList:EnumService.ClinicalMedicationRxStatus,
            PharmacyOption:{},
            isSigned: false,
            OffRoute:false,
            clickBack:false,
            WasSaved: false,
            isDuplicateDrugsVisible: false,
            emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            }
        }
    },

    methods: {

         OpenDataBank(){
            this.SearchBank = this.DrugName ? this.DrugName : "";
            this.DataBankVisible = true;
        },

        async getUrlDrugInfo(drugCode){
      await MedicationService.getUrlDrugInfo(drugCode)
            .then((response) => {
               if (response.status == '200' && response.data) {
                    window.open(response.data.url, '_blank');
               }
         })
         .catch(error => {
            this.showResponseErrorMessage(error);
         });
    },

        OpenDrugInfo(item){

            this.DrugCode = item.drugCode;
            this.DrugName = item.drugName;
            this.PatientCode = item.patientCode;

             if(!this.$store.state.UseFirstDataBank){
                this.getUrlDrugInfo(this.DrugCode);
            }else{
                this.OpenDataBank();
            }

        },

        DataBankOnCancel(){
            this.DataBankVisible = false;
        },

        UpdateDataDrugName(name){
            this.FirstDataDrugName = name;
        },

        DiscardChanges() {
            this.clickBack = true;
            if (this.isScheduleDB) {
                this.$router.push({
                    name: "appointmentDB-Medications",
                    params: { id: this.$route.params.id, actId: this.$route.params.actId },
                });
            } else {
                this.$router.push({
                    name: "Clinical-Medications",
                    params: { id: this.$route.params.id, recordid: this.$route.params.recordid },
                });
            }
        },

        async ClickOffRoute() {
            this.OffRoute = true;
            await this.SaveOrEdit();
        },

        async SaveOrEdit() {
            if (await this.ValidateRequired()) {
                if (await this.ValidateIsPrescriptionCurrent()) {
                    this.$emit('load', true);
                    const param = this.PrepareMedication();

                    await MedicationService
                        .addStandingOrders(param)
                        .then((response) => {
                            if(response.status == '200'){
                                if (!response.data.errorMessage) {
                                    this.WasSaved = true;
                                    this.setPendingChanges(false);

                                    if(!this.OffRoute /*|| this.clickBack*/){
                                        this.DiscardChanges();
                                    }

                                    setTimeout(() =>
                                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                            title: this.$t('Msg.Success'),
                                            autoHideDelay: 5000,
                                            variant: "success"
                                        })
                                    , 50);
                                } else {
                                    let position = 0;
                                    for (let index = 0; index < this.prescriptions.length; index++) {
                                        const prescription = this.prescriptions[index];
                                        if (prescription.selected) {
                                            if (position === response.data.errorIndex) {
                                                this.$refs[`StandingOrderDrug_${index}`][0].setIsValidateRequired(false, response.data.errorMessage);
                                                break;
                                            }

                                            position++;
                                        }
                                    }
                                    this.showMessage(this.$tc('Msg.Error'), response.data.errorMessage, "errorAutoHide");
                                }
                            }
                            this.$emit('load', false);
                        })
                        .catch((error) => {
                            this.$emit('load', false);
                            this.showResponseErrorMessage(error);
                        });
                }
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('StandingOrders.CheckRedLabeledFields', {'label': this.getPrescriptionInvalid()}), "errorAutoHide");
            }
        },

        existPrescriptionSelected(){
            return this.prescriptions.some(x => x.selected);
        },

        getPrescriptionInvalid() {
            const invalid = [];
            for (let index = 0; index < this.prescriptions.length; index++) {
                const prescription = this.prescriptions[index];
                if (!prescription.isValidateRequired) {
                    invalid.push(prescription.drugName)
                }
            }

            return invalid.join("', '");
        },

        async ValidateRequired() {
            this.isPrescriberValid = Utils.isNullOrEmptyString(this.ModelPrescriber.code) ? false : true;
            let isPrescriptionsValid = true;
            for (let index = 0; index < this.prescriptions.length; index++) {
                const prescription = this.prescriptions[index];
                if (prescription.selected) {
                    const isValidateRequired = await this.$refs[`StandingOrderDrug_${index}`][0].ValidateRequired();
                    isPrescriptionsValid &= isValidateRequired;
                }
            }

            return isPrescriptionsValid && this.isPrescriberValid;
        },

        async ValidateIsPrescriptionCurrent() {
            let isPrescriptionsValid = true;
            for (let index = 0; index < this.prescriptions.length && isPrescriptionsValid; index++) {
                const prescription = this.prescriptions[index];
                if (prescription.selected) {
                    isPrescriptionsValid &= (await this.$refs[`StandingOrderDrug_${index}`][0].ValidateIsPrescriptionCurrent());
                }
            }

            return isPrescriptionsValid;
        },

        PrepareMedication () {
            const obj = {
                PatientCode:this.$route.params.id,
                AdmissionRecordId: this.isScheduleDB ? this.currentAppointmentDB && String(this.currentAppointmentDB.recId) : this.$route.params.recordid,
                PrescriberCode:this.ModelPrescriber.code,
                Prescriptions: [],
                IsSigned: this.isSigned
            }

            for (let index = 0; index < this.prescriptions.length; index++) {
                const item = this.prescriptions[index];
                if (item.selected) {
                    obj.Prescriptions.push(this.$refs[`StandingOrderDrug_${index}`][0].PrepareMedication());
                }
            }

            return obj;
        },

        getStandingOrderDrugsPrescription() {
            this.$emit('load', true);
            this.prescriptions = [];

            const param = {
                Codes: this.protocol.code,
                AdmissionRecordID: this.isScheduleDB ? this.currentAppointmentDB && String(this.currentAppointmentDB.recId) : this.$route.params.recordid,
                PatientCode : this.$route.params.id,
                PrescriberCode: this.ModelPrescriber.code ? this.ModelPrescriber.code : null,
                Prescriber: this.ModelPrescriber.code ? this.ModelPrescriber.name : null,
                HeaderID: null //TODO como obtener el headerID
            };
            MedicationService.getStandingOrderDrugsPrescription(param)
                .then((response) => {
                    if(response.status == '200') {
                        this.prescriptions = response.data;
                        this.prescriptions.forEach(element => {
                            element.isValidateRequired = true;
                            element.selected = true;
                            element.errorMessage = null;
                        });

                        setTimeout(() => {
                            this.setPendingChanges(true);
                        }, 50);
                    }

                    this.$emit('load', false);
                })
                .catch((error) => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

        ChangeDropDownPrescriber(item){
            if (item !== null) {
                this.ModelPrescriber = item;
                this.PrescriptionLabel = `${this.$t('Shared.Prescriber')}: ${item.name}`;
            } else {
                this.ModelPrescriber = {code:"", name:""};
                this.PrescriptionLabel = this.$t('StandingOrders.labelSelect',{'label': this.$t('Shared.Prescriber')});
            }
        },

        onCodeConditionOk(value) {
            if (value) {
                this.protocol.code = value.code;
                this.protocol.description = value.description;
                this.getStandingOrderDrugsPrescription();
            } else {
                this.protocol.code = '';
                this.protocol.description = '';
            }
        },

        toggleSelectState(event, index) {
            event.preventDefault();
            this.$refs[`StandingOrderDrug_${index}`][0].toggleSelectState();
        },

        setPendingChanges(value) {
            for (let index = 0; index < this.prescriptions.length; index++) {
                this.$refs[`StandingOrderDrug_${index}`][0].setPendingChanges(value);
            }
        },

        getPendingChanges() {
            let pendingChanges = false;
            for (let index = 0; index < this.prescriptions.length; index++) {
                pendingChanges |= this.$refs[`StandingOrderDrug_${index}`][0].getPendingChanges();
            }

            return this.prescriptions.length !== 0 ? pendingChanges : false;
        },

        PrescriberExist(code){
            for(var i = 0; i < this.PrescriberList.length; i++){
                if( this.PrescriberList[i].code &&  this.PrescriberList[i].code.toUpperCase().trim() === code && code.toUpperCase().trim()){
                    return true;
                }
            }
            return false;
        },

        async getPrescribers(){
            this.$emit('load', true);
            await MedicationService
                .getPrescribers()
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.PrescriberList = response.data;
                    }
                    this.$emit('load', false);
                })
                .catch((error) => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

        async getDiagnosisByPatientCode() {
            await PatientService
                .getDiagnosisListByPatientCode(this.$route.params.id)
                .then((response) => {
                    if (response.data) {
                        this.DiagnosisList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getIndicationsList() {
            await IndicationService
                .getIndications()
                .then((response) => {
                    if (response.data) {
                        this.IndicationsList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getAction(){
            var param = {
                CodeType:"ACTION",
                GroupCreation:"SIG"
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ActionList = response.data;
                        this.ActionList.forEach(element => {
                            element.code = element.description;
                        });
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        getRouteName(){
            var param = {
                CodeType:"ROUTE",
                GroupCreation:"SIG"
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.RouteNameList = response.data;
                        this.RouteNameList.forEach(element => {
                            element.code = element.description;
                        });
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        getWhen(){
            var param = {
                CodeType:"WHEN",
                GroupCreation:"SIG"
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.WhenList = response.data;
                        this.WhenList.forEach(element => {
                            element.code = element.description;
                        });
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        getOrderType(){
            var param = {
                CodeType:"ORDERTYPE",
                GroupCreation:null
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.OrderTypeList = response.data;
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        getReason(){
            var param = {
                CodeType:"REASON",
                GroupCreation:"SIG"
            };
            GlobalService
                .getCustomGlobalCodes(param)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.ReasonList = response.data;
                        this.ReasonList.forEach(element => {
                            element.code = element.description;
                        });
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getDefaultDoctor() {
            await PatientService
                    .getDefaultDoctor(this.$route.params.id)
                    .then((response) => {
                        if(response.status == '200'){
                            this.defaultDoctor = response.data;

                            if(this.PrescriberExist(this.defaultDoctor.doctorCode)){
                                this.ModelPrescriber.code = this.defaultDoctor.doctorCode;
                                this.ModelPrescriber.name = this.defaultDoctor.doctorName;
                            }
                        }
                        this.$emit('load', false);
                    })
                    .catch((error) => {
                        this.$emit('load', false);
                        this.showResponseErrorMessage(error);
                    });
        },

        async setDefaultDoctor() {
            if (this.PharmacyOption && this.PharmacyOption.usePatientDoctorAsPrescriber) {
                await this.getDefaultDoctor()
            } else {
                if(this.PrescriberExist(this.$store.state.employeeCode)) {
                    this.ModelPrescriber.code = this.$store.state.employeeCode;
                    this.ModelPrescriber.name = Utils.strToTitleCase(StorageService.getName());
                }
            }
        },

        getPharmacyOptions(){
            PharmacyOptions
                .getPharmacyOptions()
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.PharmacyOption = response.data[0];
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`
        },

        async GetPatientByCode(){
            let infoList = await this.getInfoTitle(this.$route.params.id);
            if(infoList.length > 0){
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;
            }
        },

        onLoad() {
            this.$emit('load', true),
            Promise.allSettled([this.getPharmacyOptions(), this.getPrescribers()])
                .then((result) => result.length == 2 ?
                        Promise.allSettled([this.getDiagnosisByPatientCode(),
                                        this.getIndicationsList(),
                                        this.getAction(),
                                        this.getRouteName(),
                                        this.getWhen(),
                                        this.getOrderType(),
                                        this.getReason(),
                                        this.setDefaultDoctor(),
                                ])
                                .then((result) => result.length == 8 ? this.$emit('load', false) : null)
                                .catch((error) => {
                                    this.$emit('load', false);
                                    this.showResponseErrorMessage(error);
                                })
                        : null)
                .catch((error) => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        }
    },

    async mounted() {
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
        this.isScheduleDB = this.$route.name.includes('Appointments-medications-standing-order');
        if (this.isScheduleDB) {
            await this.getCurrentAppointment()
            await this.GetPatientByCode();

            if (this.currentAppointmentDB && this.currentAppointmentDB.admissionRecordId) {
                this.RegistrationInfo = await this.getRegistrationInfoTitle(this.currentAppointmentDB.admissionRecordId);
            }
        } else {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);
            if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
        }

        this.onLoad();
        EventBus.$on("ShowWeel", function (isShow) {
            isShow ? this.$emit('load', true) : this.$emit('load', false);
        }.bind(this));
    },

    beforeDestroy () {
        EventBus.$off("ShowWeel");
    }
}
</script>

<style scoped>
/* MODAL REMAKE */
.zebraAccordion{
    margin: 0 0;
}
.resetFontSize small{
    font-size: .95em;
}
.zebraAccordion .zebraRow .zebraItem{
    border-radius: 4px 4px 0 0;
    padding: 5px;
    width: 100%;
    cursor: pointer;
    transition: all .3s ease-in-out;
}

.zebraAccordion .zebraRow:nth-child(odd) .zebraItem{
    background-color: #d4f7ff;
}
.zebraAccordion .zebraRow:nth-child(even) .zebraItem{
    background-color: #ecfcff;
}

.zebraAccordion .zebraRow .accordion .zebraItem.not-collapsed {
    background-color: #19BEE1;
    color: #FFF;
}
.zebraAccordion .zebraRow .accordion .zebraItem:hover {
    background-color: #64d6f0;
    color: #FFF;
}
.accordionContent{
    border-top: 0;
    background: linear-gradient(173deg, #D9F4FB, #FFF 30% );
    padding-top: 3em;
}
.PRNlabel{
    background-color: #6F6;
    border-radius: 10px;
    padding: 0 10px;
    color: #060 !important;
    transition: all .3s ease-in-out;
}
.PRNlabel:hover{
    background-color: #FF9;
}
.blinkingSTAT{
    color: #FF0;
    background-color: #C00;
    border-radius: 10px;
    padding: 0 5px;
    animation: blinkSTAT 1s steps(5, start) infinite;
}
@keyframes blinkSTAT {
to {
    visibility: hidden;
    }
}

.checkboxBTN{
    background-color: #FFF  !important;
    border: 1px dashed #19BEE1 !important;
}

.checkboxBTN:hover{
    background-color: #19BEE1  !important;
    border: 1px dashed #FFF !important;
}

.checkboxBTN::before{
    color: #19BEE1;
    opacity: 0.5;
}
.checkboxBTN:hover::before{
    opacity: 1;
    color: #FFF;
}

.checkboxBTNChecked{
    background-color: #87e819 !important;
    border: 1px solid #FFF !important;
    font-weight: bold;
}

.checkboxBTNChecked:hover{
    background-color: #07ce00 !important;
}
</style>
